/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GetOrCreateGreenMachineSessionsInput = {|
  slateId: string,
  clientMutationId?: ?string,
|};
export type GetOrCreateGreenMachineSessionMutationVariables = {|
  input: GetOrCreateGreenMachineSessionsInput
|};
export type GetOrCreateGreenMachineSessionMutationResponse = {|
  +getOrCreateGreenMachineSessions: ?{|
    +greenMachineSessions: ?$ReadOnlyArray<?{|
      +id: string,
      +numLineups: number,
      +minSalary: number,
      +maxSalary: number,
      +playersPerLineup: ?number,
      +greenmachinelineupsetSet: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string
          |}
        |}>
      |},
      +slate: {|
        +gameType: {|
          +gametypelineupsetSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +lineupSet: {|
                  +lineuprosterslotSet: {|
                    +edges: $ReadOnlyArray<?{|
                      +node: ?{|
                        +order: number,
                        +amount: number,
                        +rosterSlot: {|
                          +name: string
                        |},
                        +selectable: boolean,
                      |}
                    |}>
                  |}
                |}
              |}
            |}>
          |}
        |}
      |},
    |}>
  |}
|};
export type GetOrCreateGreenMachineSessionMutation = {|
  variables: GetOrCreateGreenMachineSessionMutationVariables,
  response: GetOrCreateGreenMachineSessionMutationResponse,
|};
*/


/*
mutation GetOrCreateGreenMachineSessionMutation(
  $input: GetOrCreateGreenMachineSessionsInput!
) {
  getOrCreateGreenMachineSessions(input: $input) {
    greenMachineSessions {
      id
      numLineups
      minSalary
      maxSalary
      playersPerLineup
      greenmachinelineupsetSet {
        edges {
          node {
            id
          }
        }
      }
      slate {
        gameType {
          gametypelineupsetSet {
            edges {
              node {
                lineupSet {
                  lineuprosterslotSet {
                    edges {
                      node {
                        order
                        amount
                        rosterSlot {
                          name
                          id
                        }
                        selectable
                        id
                      }
                    }
                  }
                  id
                }
                id
              }
            }
          }
          id
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numLineups",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minSalary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxSalary",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playersPerLineup",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "GreenMachineLineupSetTypeConnection",
  "kind": "LinkedField",
  "name": "greenmachinelineupsetSet",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GreenMachineLineupSetTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GreenMachineLineupSetType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectable",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetOrCreateGreenMachineSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GetOrCreateGreenMachineSessionsPayload",
        "kind": "LinkedField",
        "name": "getOrCreateGreenMachineSessions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineSessionType",
            "kind": "LinkedField",
            "name": "greenMachineSessions",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateType",
                "kind": "LinkedField",
                "name": "slate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeType",
                    "kind": "LinkedField",
                    "name": "gameType",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeLineupSetTypeConnection",
                        "kind": "LinkedField",
                        "name": "gametypelineupsetSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTypeLineupSetTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GameTypeLineupSetType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupSetType",
                                    "kind": "LinkedField",
                                    "name": "lineupSet",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LineupRosterSlotTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "lineuprosterslotSet",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LineupRosterSlotTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "LineupRosterSlotType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v9/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "RosterSlotType",
                                                    "kind": "LinkedField",
                                                    "name": "rosterSlot",
                                                    "plural": false,
                                                    "selections": [
                                                      (v10/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v11/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetOrCreateGreenMachineSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GetOrCreateGreenMachineSessionsPayload",
        "kind": "LinkedField",
        "name": "getOrCreateGreenMachineSessions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineSessionType",
            "kind": "LinkedField",
            "name": "greenMachineSessions",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlateType",
                "kind": "LinkedField",
                "name": "slate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GameTypeType",
                    "kind": "LinkedField",
                    "name": "gameType",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GameTypeLineupSetTypeConnection",
                        "kind": "LinkedField",
                        "name": "gametypelineupsetSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GameTypeLineupSetTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GameTypeLineupSetType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LineupSetType",
                                    "kind": "LinkedField",
                                    "name": "lineupSet",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LineupRosterSlotTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "lineuprosterslotSet",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LineupRosterSlotTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "LineupRosterSlotType",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v9/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "RosterSlotType",
                                                    "kind": "LinkedField",
                                                    "name": "rosterSlot",
                                                    "plural": false,
                                                    "selections": [
                                                      (v10/*: any*/),
                                                      (v2/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v11/*: any*/),
                                                  (v2/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbf160dc6cc3ea5c8bbb708ce234e4ed",
    "id": null,
    "metadata": {},
    "name": "GetOrCreateGreenMachineSessionMutation",
    "operationKind": "mutation",
    "text": "mutation GetOrCreateGreenMachineSessionMutation(\n  $input: GetOrCreateGreenMachineSessionsInput!\n) {\n  getOrCreateGreenMachineSessions(input: $input) {\n    greenMachineSessions {\n      id\n      numLineups\n      minSalary\n      maxSalary\n      playersPerLineup\n      greenmachinelineupsetSet {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      slate {\n        gameType {\n          gametypelineupsetSet {\n            edges {\n              node {\n                lineupSet {\n                  lineuprosterslotSet {\n                    edges {\n                      node {\n                        order\n                        amount\n                        rosterSlot {\n                          name\n                          id\n                        }\n                        selectable\n                        id\n                      }\n                    }\n                  }\n                  id\n                }\n                id\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9b81f0e7ec42891bbcf52179543ba9c9';

module.exports = node;
